import List from "./ListPage";

const resource = {
  list: List,
};

export default resource;
